import React from 'react';
import { BaseInputProps, useInputHelper } from 'ui-builder';
import Layout from './Layout';

export interface ColorPickerWithTextProps extends BaseInputProps<string> {
  defaultColor?: string;
}

export function ColorPickerWithText(props: ColorPickerWithTextProps) {
  const inputHelper = useInputHelper<string>(props);

  return (
    <Layout
      {...inputHelper.getBaseInputLayoutProps()}
      defaultColor={props.defaultColor}
    />
  );
}
